import "./style/index.scss";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import { Form, Row, Col, Checkbox, Radio, Space, Button, DatePicker, Switch, Divider, Input, Select } from "antd";
import TextArea from "antd/lib/input/TextArea";
import dayjs from "dayjs";
import { useEffect } from "react";
import { PlanoContaFinanceiroModel } from "../../../../models/planoContaFinanceiro/planoContaFinanceiroModel";
import { setBuscaPlanoContaFinanceiro, setModalCadastrarPlanoContaFinanceiro } from "../../../../redux/slices/planoContaFinanceiro/planoContaFinanceiroSlice";
import { buscarPlanoContaContabil } from "../../../../services/planoContaContabilService";
import { atualizarPlanoContaFinanceiro, buscarPlanoContaFinanceiro, cadastrarPlanoContaFinanceiro } from "../../../../services/planoContaFinanceiroService";
import { useAppSelector, useAppDispatch } from "../../../../util/hooks";
import "dayjs/locale/pt-br";
import { buscarGrupoPlanoContaFinanceiro } from "../../../../services/grupoPlanoContaFinanceiroService";
import { findNodeById } from "../../../../util/functions/findNodeById";
import SelectTree from "../../../../components/inputs/selectTree";
import { BuscaPlanoContaFinanceiroModel } from "../../../../models/planoContaFinanceiro/buscaPlanoContaFinanceiroModel";
import SelectTreeCadastro from "../../components/selectTreeCadastro";

dayjs.locale("pt-br");

type CadastroEdicaoPlanoContaFinanceiroProps = {
  idPlanoCadastro: number;
};

const CadastroEdicaoPlanoContaFinanceiro = ({ idPlanoCadastro }: CadastroEdicaoPlanoContaFinanceiroProps) => {
  //estados globais
  const planoContaFinanceiroState = useAppSelector((state) => state.planoContaFinanceiro);
  const planoContaContabilState = useAppSelector((state) => state.planoContaContabil);
  const grupoPlanoContaFinanceiroState = useAppSelector((state) => state.grupoPlanoContaFinanceiro);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm<PlanoContaFinanceiroModel>();

  const editar = Object.values(planoContaFinanceiroState.entity).length !== 0;

  const watchAtivo = Form.useWatch("ativo", form);

  useEffect(() => {
    dispatch(buscarGrupoPlanoContaFinanceiro(grupoPlanoContaFinanceiroState.busca));
    dispatch(buscarPlanoContaContabil({ ...planoContaContabilState.busca, ativo: true }));
    if (editar) {
      form.setFieldsValue({
        ...planoContaFinanceiroState.entity,
        dataInativacao: planoContaFinanceiroState.entity.ativo !== null && dayjs(planoContaFinanceiroState.entity.dataInativacao),
        receitaDespesa: planoContaFinanceiroState.entity.receitaDespesa.toLowerCase(),
        sinteticoAnalitico: planoContaFinanceiroState.entity.sinteticoAnalitico.toLowerCase(),
      });
    } else {
      form.setFieldsValue({
        ativo: true,
        sinteticoAnalitico: "a",
        codigo: "",
      });

      if (idPlanoCadastro !== 0) {
        const plano = findNodeById(planoContaFinanceiroState.list, idPlanoCadastro);
        form.setFieldsValue({ receitaDespesa: plano.receitaDespesa.toLowerCase(), idGrupoPlanoContaFinanceiro: plano.idGrupoPlanoContaFinanceiro, idPai: idPlanoCadastro });
      }
    }
  }, [planoContaFinanceiroState.entity]);

  const onChangeGrupo = (value: number) => {
    let busca: BuscaPlanoContaFinanceiroModel = { ...planoContaFinanceiroState.busca, idGrupoPlanoContaFinanceiro: value };

    dispatch(setBuscaPlanoContaFinanceiro(busca));
    dispatch(buscarPlanoContaFinanceiro(busca));
  };

  const onChangeForm = (values: any) => {
    if (values.idPai) {
      if (values.idPai !== null || values.idPai !== undefined) {
        form.setFieldValue("receitaDespesa", findNodeById(planoContaFinanceiroState.list, values.idPai)?.receitaDespesa.toLowerCase());
      }
    }
    if (values.ativo) {
      form.setFieldValue("dataInativacao", null);
    }
  };

  const submit = (values: any) => {
    values.dataInativacao = values.ativo ? null : values.dataInativacao;
    values.idPlanoContaContabil = values.idPlanoContaContabil === undefined ? null : values.idPlanoContaContabil;
    values.descricao = values.descricao === undefined ? null : values.descricao;
    const submitPlanoContaFinanceiro: PlanoContaFinanceiroModel = { ...values };

    if (editar) {
      submitPlanoContaFinanceiro.id = planoContaFinanceiroState.entity.id;
      dispatch(atualizarPlanoContaFinanceiro({ value: submitPlanoContaFinanceiro, busca: planoContaFinanceiroState.busca }));
    } else {
      dispatch(cadastrarPlanoContaFinanceiro({ value: values, busca: planoContaFinanceiroState.busca }));
    }
  };

  const voltar = () => {
    dispatch(setModalCadastrarPlanoContaFinanceiro(false));
  };

  return (
    <Form form={form} onFinish={submit} layout="vertical" onValuesChange={onChangeForm}>
      <Row gutter={12}>
        <Col>
          <Form.Item
            label="Grupo de plano de conta financeiro"
            name="idGrupoPlanoContaFinanceiro"
            rules={[
              {
                required: true,
                message: "Escolha um grupo de plano de conta financeiro",
              },
            ]}
          >
            <Select
              onChange={onChangeGrupo}
              loading={grupoPlanoContaFinanceiroState.loading}
              options={grupoPlanoContaFinanceiroState.list.map((a: any) => ({
                value: a.id,
                label: a.denominacao,
              }))}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Item Superior"
            name="idPai"
            rules={[
              {
                required: true,
                message: "Escolha um item superior",
              },
            ]}
          >
            <SelectTreeCadastro loading={planoContaFinanceiroState.loading} list={planoContaFinanceiroState.list} />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item label="Código" name="codigo">
            <Input type="text" disabled />
          </Form.Item>
        </Col>
        <Col span={2}>
          <Form.Item name="ativo" label=" " valuePropName="checked">
            <Checkbox name="ativo" style={{ fontSize: "14px", paddingTop: "5px" }}>
              Ativo
            </Checkbox>
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item label="Data de inativação" name="dataInativacao">
            <DatePicker format="DD/MM/YYYY" disabled={watchAtivo} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={12}>
          <Form.Item
            label="Conta financeira"
            name="denominacao"
            rules={[
              {
                required: true,
                message: "Digite a denominação da conta financeira",
              },
            ]}
          >
            <Input type="text" placeholder="Digite a denominação" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="receitaDespesa" label="Categoria">
            <Radio.Group buttonStyle="solid" disabled className="disabledCateg">
              <Radio.Button value="r">Receita</Radio.Button>
              <Radio.Button value="d">Despesa</Radio.Button>
            </Radio.Group>
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item name="sinteticoAnalitico" label="Tipo">
            <Radio.Group buttonStyle="solid">
              <Radio.Button value="s">Sintético</Radio.Button>
              <Radio.Button value="a">Analítico</Radio.Button>
            </Radio.Group>
          </Form.Item>
        </Col>
        <Col span={2}>
          <Form.Item label="Redutor" name="redutor" valuePropName="checked">
            <Switch size="small" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={12}>
          <Form.Item label="Conta contábil" name="idPlanoContaContabil">
            <SelectTree loading={planoContaContabilState.loading} list={planoContaContabilState.list} />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item label="Descrição" name="descricao">
            <TextArea rows={3} />
          </Form.Item>
        </Col>
      </Row>
      <Divider></Divider>
      <Row gutter={12}>
        <Col span={24} className="modalFooter">
          <Space size="middle">
            <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
              FECHAR
            </Button>
            <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
              {editar ? "ATUALIZAR" : "SALVAR"}
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default CadastroEdicaoPlanoContaFinanceiro;
